if (!customElements.get('premium-memory-strip')) {
  customElements.define('premium-memory-strip', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        this.toggleAttribute('data-offscreen', !entry.isIntersecting);
      }, { rootMargin: '100px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
